export const accordionTheme = {
  extend: {
    custom: {
      /** Width and height for the accordion header toggle (chevron / custom icons). */
      toggleIconSize: "1.5rem",
    },
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-accordionheader .p-icon,
    .p-accordionheader svg[data-p-icon] {
      width: ${dt("accordion.custom.toggleIconSize")};
      height: ${dt("accordion.custom.toggleIconSize")};
      min-width: ${dt("accordion.custom.toggleIconSize")};
      min-height: ${dt("accordion.custom.toggleIconSize")};
    }
  `,
};
